var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon16/service/cancel-alt",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M10.7923882,4.82842712 L7.96396103,7.65685425 L5.13553391,4.82842712 L4.42842712,5.53553391 L7.25685425,8.36396103 L4.42842712,11.1923882 L5.13553391,11.8994949 L7.96396103,9.07106781 L10.7923882,11.8994949 L11.4994949,11.1923882 L8.67106781,8.36396103 L11.4994949,5.53553391 L10.7923882,4.82842712 Z",
    id: "warning"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelAlt);
export default __webpack_public_path__ + "static/media/cancel-alt.e65ce023d53217e1f4a72f16ad4f3f30.svg";
export { ForwardRef as ReactComponent };